<template>
  <Card class="illegal-release-form">
    <Form ref="dataForm" style="max-width:500px" :model="formItem" :rules="ruleValidate" :label-width="140">
      <Form-item label="重大违法责任主体" prop="IllegalSubject">
        <Input v-model="formItem.IllegalSubject" placeholder="请输入重大违法责任主体"></Input>
      </Form-item>
      <Form-item label='违法区域' prop="Region">
        <city-select-list :city="formItem.Region" @selectCity="selectCity"></city-select-list>
      </Form-item>
      <Form-item label="违法时间" prop="IllegalDate">
        <DatePicker v-model="formItem.IllegalDate" type="date" placeholder="请选择" style="width: 200px"></DatePicker>
      </Form-item>
      <Form-item label="违法内容" prop="IllegalContent">
        <Input type="textarea" v-model="formItem.IllegalContent" :autosize="{minRows: 2,maxRows: 8}" placeholder="请输入违法内容"></Input>
      </Form-item>
      <Form-item label="监管部门" prop="SupervisorName">
        <Input v-model="formItem.SupervisorName" placeholder="请输入监管部门"></Input>
      </Form-item>
      <FormItem>
        <Button type="primary" size="large" long :loading="submitting" @click="submitFrom">{{ editMode?'提交修改':'提交新增' }}</Button>
      </FormItem>
    </Form>
  </Card>
</template>

<script>
import citySelectList from '../public/CitySelectList'
import leftPad from 'leftpad'
export default {
  name: 'illegal-release-form',
  components: {
    citySelectList,
  },
  props: {
    data: {
      type: Object,
      default: () => null
    }
  },
  watch: {
    data: function (newVal) {
      if (newVal) {
        Object.assign(this.formItem, newVal)
        this.editMode = true
      } else {
        this.editMode = false
        this.formItem = {
          IllegalSubject: null,
          IllegalDate: null,
          IllegalContent: null,
          Region: null,
          Province: null,
          Municipality: null,
          County: null,
          SupervisorName: null,
          Operator: null
        }
      }
    },
  },
  data () {
    return {
      visible: false,
      editMode: false,
      formItem: {
        Tid: null,
        IllegalSubject: null,
        IllegalDate: null,
        IllegalContent: null,
        Region: null,
        Province: null,
        Municipality: null,
        County: null,
        SupervisorName: null,
        Operator: null
      },
      ruleValidate: {
        IllegalSubject: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        IllegalDate: [
          { required: true, type: 'date', message: '不能为空', trigger: 'blur' }
        ],
        IllegalContent: [
          { required: true, message: '不能为空', trigger: 'blur' },
        ],
        SupervisorName: [
          { required: true, message: '不能为空', trigger: 'blur' },
        ],
        Region: [
          { required: true, message: '不能为空', trigger: 'blur' },
        ],
      },
      submitEnabled: true,
      submitting: false
    }
  },
  mounted () {
    if (this.$store.getters.name) {
      this.formItem.Operator = this.$store.getters.name
    }
    let curItem = localStorage.getItem('illegal-release-current')
    if (curItem) {
      curItem = JSON.parse(curItem)
    }
    if (curItem && curItem.Tid && curItem.Tid.toString() === this.$route.params.tid) {
      this.formItem = curItem
      this.editMode = true
      if (curItem.Province > 0) {
        this.getCityCode(curItem.Province, curItem.Municipality, curItem.County)
      }
    }
  },
  methods: {
    selectCity (value) {
      this.formItem.Region = value
      if (value.length > 0) {
        this.formItem.Province = parseInt(value.substr(0, 2))
        this.formItem.Municipality = parseInt(value.substr(2, 2))
        this.formItem.County = parseInt(value.substr(4, 2))
      } else {
        this.formItem.Province = 0
        this.formItem.Municipality = 0
        this.formItem.County = 0
      }
    },
    getCityCode (province, municipality, county) {
      this.formItem.Region = leftPad(province, 2) +
        leftPad(municipality, 2) +
        leftPad(county, 2)
    },
    submitFrom () {
      if (this.editMode) {
        return this.edit()
      } else {
        return this.create()
      }
    },
    create () {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.submitting = true
          this.submitEnabled = false
          this.$Spin.show()
          this.$Api.Project.addIllegalRelease(this.formItem).then(() => {
            this.$Message.success('操作成功！!')
            this.$Spin.hide()
            this.submitEnabled = true
            this.submitting = false
            this.formItem = {
              IllegalSubject: null,
              IllegalDate: null,
              IllegalContent: null,
              Region: null,
              Province: null,
              Municipality: null,
              County: null,
              SupervisorName: null,
              Operator: null
            }
          }).catch(err => {
            this.$Spin.hide()
            this.$Message.error('提交失败！!' + err.message)
            this.submitEnabled = true
            this.submitting = false
          })
        } else {
          this.$Message.error('表单验证失败!')
          this.submitEnabled = true
          this.submitting = false
        }
      })
    },
    edit () {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.submitting = true
          this.submitEnabled = false
          this.$Spin.show()
          this.$Api.Project.editIllegalRelease(this.formItem).then(() => {
            this.$Message.success('操作成功！!')
            this.$Spin.hide()
            this.submitEnabled = true
            this.submitting = false
          }).catch(err => {
            this.$Spin.hide()
            this.$Message.error('提交失败！!' + err.message)
            this.submitEnabled = true
            this.submitting = false
          })
        } else {
          this.$Message.error('表单验证失败!')
          this.submitEnabled = true
          this.submitting = false
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
